// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* color palette from <https://github.com/vuejs/theme> */
:root {
  --vt-c-white: #ffffff;
  --vt-c-white-soft: #f8f8f8;
  --vt-c-white-mute: #f2f2f2;

  --vt-c-black: #181818;
  --vt-c-black-soft: #222222;
  --vt-c-black-mute: #282828;

  --vt-c-indigo: #2c3e50;

  --vt-c-divider-light-1: rgba(60, 60, 60, 0.29);
  --vt-c-divider-light-2: rgba(60, 60, 60, 0.12);
  --vt-c-divider-dark-1: rgba(84, 84, 84, 0.65);
  --vt-c-divider-dark-2: rgba(84, 84, 84, 0.48);

  --vt-c-text-light-1: var(--vt-c-indigo);
  --vt-c-text-light-2: rgba(60, 60, 60, 0.66);
  --vt-c-text-dark-1: var(--vt-c-white);
  --vt-c-text-dark-2: rgba(235, 235, 235, 0.64);
}

/* semantic color variables for this project */
:root {
  --color-background: var(--vt-c-white);
  --color-background-soft: var(--vt-c-white-soft);
  --color-background-mute: var(--vt-c-white-mute);

  --color-border: var(--vt-c-divider-light-2);
  --color-border-hover: var(--vt-c-divider-light-1);

  --color-heading: var(--vt-c-text-light-1);
  --color-text: var(--vt-c-text-light-1);

  --section-gap: 160px;
}

@media (prefers-color-scheme: dark) {
  :root {
    --color-background: var(--vt-c-black);
    --color-background-soft: var(--vt-c-black-soft);
    --color-background-mute: var(--vt-c-black-mute);

    --color-border: var(--vt-c-divider-dark-2);
    --color-border-hover: var(--vt-c-divider-dark-1);

    --color-heading: var(--vt-c-text-dark-1);
    --color-text: var(--vt-c-text-dark-2);
  }
}

*,
*::before,
*::after {
  box-sizing: border-box;
  margin: 0;
  font-weight: normal;
}

body {
  min-height: 100vh;
  color: var(--color-text);
  background: var(--color-background);
  transition:
    color 0.5s,
    background-color 0.5s;
  line-height: 1.6;
  font-family:
    Inter,
    -apple-system,
    BlinkMacSystemFont,
    'Segoe UI',
    Roboto,
    Oxygen,
    Ubuntu,
    Cantarell,
    'Fira Sans',
    'Droid Sans',
    'Helvetica Neue',
    sans-serif;
  font-size: 15px;
  text-rendering: optimizeLegibility;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
`, "",{"version":3,"sources":["webpack://./src/assets/base.css"],"names":[],"mappings":"AAAA,wDAAwD;AACxD;EACE,qBAAqB;EACrB,0BAA0B;EAC1B,0BAA0B;;EAE1B,qBAAqB;EACrB,0BAA0B;EAC1B,0BAA0B;;EAE1B,sBAAsB;;EAEtB,8CAA8C;EAC9C,8CAA8C;EAC9C,6CAA6C;EAC7C,6CAA6C;;EAE7C,uCAAuC;EACvC,2CAA2C;EAC3C,qCAAqC;EACrC,6CAA6C;AAC/C;;AAEA,8CAA8C;AAC9C;EACE,qCAAqC;EACrC,+CAA+C;EAC/C,+CAA+C;;EAE/C,2CAA2C;EAC3C,iDAAiD;;EAEjD,yCAAyC;EACzC,sCAAsC;;EAEtC,oBAAoB;AACtB;;AAEA;EACE;IACE,qCAAqC;IACrC,+CAA+C;IAC/C,+CAA+C;;IAE/C,0CAA0C;IAC1C,gDAAgD;;IAEhD,wCAAwC;IACxC,qCAAqC;EACvC;AACF;;AAEA;;;EAGE,sBAAsB;EACtB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,wBAAwB;EACxB,mCAAmC;EACnC;;yBAEuB;EACvB,gBAAgB;EAChB;;;;;;;;;;;;cAYY;EACZ,eAAe;EACf,kCAAkC;EAClC,mCAAmC;EACnC,kCAAkC;AACpC","sourcesContent":["/* color palette from <https://github.com/vuejs/theme> */\r\n:root {\r\n  --vt-c-white: #ffffff;\r\n  --vt-c-white-soft: #f8f8f8;\r\n  --vt-c-white-mute: #f2f2f2;\r\n\r\n  --vt-c-black: #181818;\r\n  --vt-c-black-soft: #222222;\r\n  --vt-c-black-mute: #282828;\r\n\r\n  --vt-c-indigo: #2c3e50;\r\n\r\n  --vt-c-divider-light-1: rgba(60, 60, 60, 0.29);\r\n  --vt-c-divider-light-2: rgba(60, 60, 60, 0.12);\r\n  --vt-c-divider-dark-1: rgba(84, 84, 84, 0.65);\r\n  --vt-c-divider-dark-2: rgba(84, 84, 84, 0.48);\r\n\r\n  --vt-c-text-light-1: var(--vt-c-indigo);\r\n  --vt-c-text-light-2: rgba(60, 60, 60, 0.66);\r\n  --vt-c-text-dark-1: var(--vt-c-white);\r\n  --vt-c-text-dark-2: rgba(235, 235, 235, 0.64);\r\n}\r\n\r\n/* semantic color variables for this project */\r\n:root {\r\n  --color-background: var(--vt-c-white);\r\n  --color-background-soft: var(--vt-c-white-soft);\r\n  --color-background-mute: var(--vt-c-white-mute);\r\n\r\n  --color-border: var(--vt-c-divider-light-2);\r\n  --color-border-hover: var(--vt-c-divider-light-1);\r\n\r\n  --color-heading: var(--vt-c-text-light-1);\r\n  --color-text: var(--vt-c-text-light-1);\r\n\r\n  --section-gap: 160px;\r\n}\r\n\r\n@media (prefers-color-scheme: dark) {\r\n  :root {\r\n    --color-background: var(--vt-c-black);\r\n    --color-background-soft: var(--vt-c-black-soft);\r\n    --color-background-mute: var(--vt-c-black-mute);\r\n\r\n    --color-border: var(--vt-c-divider-dark-2);\r\n    --color-border-hover: var(--vt-c-divider-dark-1);\r\n\r\n    --color-heading: var(--vt-c-text-dark-1);\r\n    --color-text: var(--vt-c-text-dark-2);\r\n  }\r\n}\r\n\r\n*,\r\n*::before,\r\n*::after {\r\n  box-sizing: border-box;\r\n  margin: 0;\r\n  font-weight: normal;\r\n}\r\n\r\nbody {\r\n  min-height: 100vh;\r\n  color: var(--color-text);\r\n  background: var(--color-background);\r\n  transition:\r\n    color 0.5s,\r\n    background-color 0.5s;\r\n  line-height: 1.6;\r\n  font-family:\r\n    Inter,\r\n    -apple-system,\r\n    BlinkMacSystemFont,\r\n    'Segoe UI',\r\n    Roboto,\r\n    Oxygen,\r\n    Ubuntu,\r\n    Cantarell,\r\n    'Fira Sans',\r\n    'Droid Sans',\r\n    'Helvetica Neue',\r\n    sans-serif;\r\n  font-size: 15px;\r\n  text-rendering: optimizeLegibility;\r\n  -webkit-font-smoothing: antialiased;\r\n  -moz-osx-font-smoothing: grayscale;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
